import TransitIndicator from './TransitIndicator';

export default TransitIndicator;
